// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mXRE","field":"styles_field__1oJfq","fieldCol":"styles_fieldCol__2NKWn","diffCol":"styles_diffCol__cJeJ2","diff":"styles_diff__3gV1n"};